import { TicketMessage, TicketSenderRole } from './ticket.models';

export type TicketMessageReadState = 'sent' | 'read';

export function ticketMessageSenderId(message: TicketMessage): string | null {
  if (message.senderRole === TicketSenderRole.USER) {
    return typeof message.userId === 'string'
      ? message.userId
      : (message.userId?.id ?? null);
  }
  return message.adminId ?? null;
}

export function ticketMessageSenderName(
  message: TicketMessage,
  roleLabel: (role: TicketSenderRole) => string,
): string {
  if (
    message.userId &&
    typeof message.userId === 'object' &&
    message.userId.name.trim()
  ) {
    return message.userId.name.trim();
  }
  return roleLabel(message.senderRole);
}

export function isOwnTicketMessage(
  message: TicketMessage,
  currentRole: TicketSenderRole,
  currentSenderId?: string | null,
): boolean {
  const senderId = ticketMessageSenderId(message);
  if (currentSenderId && senderId) {
    return message.senderRole === currentRole && senderId === currentSenderId;
  }
  return message.senderRole === currentRole;
}

export function isAudioOnlyTicketMessage(message: TicketMessage): boolean {
  return (
    !!message.audioUrl &&
    !message.text?.trim() &&
    !message.videoUrl &&
    !message.attachments?.length
  );
}

export function ticketMessageReadState(
  message: TicketMessage,
  currentRole: TicketSenderRole,
  currentSenderId?: string | null,
): TicketMessageReadState | null {
  if (!isOwnTicketMessage(message, currentRole, currentSenderId)) return null;
  return message.isRead ? 'read' : 'sent';
}

export function mergeTicketMessages(
  current: TicketMessage[],
  incoming: TicketMessage[],
): TicketMessage[] {
  const byId = new Map(current.map((message) => [message.id, message]));
  incoming.forEach((message) => byId.set(message.id, message));

  return [...byId.values()].sort(
    (a, b) =>
      new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime() ||
      a.id.localeCompare(b.id),
  );
}
